/**
* ページトップのコンストラクタ
* @constructor
* @param {selector} el - セレクタ
*/
module.exports = Scroll = function(el, options){
  this.element = $(el);
  this.stopEl = (options.stopEl) ? $(options.stopEl) : null;
  this.isHidden = (options.isHidden) ? $(options.isHidden) : false;
  this.init();
};

/**
* init
*/
Scroll.prototype.init = function(){
  this.win = $(window);
  this.doc = $(document);
  this.event();
};

/**
* event
*/
Scroll.prototype.event = function(){
  var self = this;

  // if(!this.stopElement.length) return;

  var visible = 'is-visible';
  var absolute = 'is-absolute';

  var winHeight = this.win.height();
  var stopPos = 0;
  var currentPos;

  self.element.on('click', function(e){
    var pos = (self.stopEl) ? self.stopEl.offset().top : 0;
    e.preventDefault();
    $('html, body').animate({scrollTop: pos}, 300, 'swing');
    return false;
  });

  self.win.on({
    // 'load': function(){
    //   stopPos = self.stopElement.offset().top + self.element.outerHeight();
    // },
    'scroll touchmove': function(){
      currentPos = $(this).scrollTop();
      if(currentPos > 20){
        self.element.addClass(visible);
      }else{
        self.element.removeClass(visible);
      }
      // if(currentPos + winHeight > stopPos){
      //   self.element.addClass(absolute).css('top', stopPos - self.element.outerHeight());
      // }else{
      //   self.element.removeClass(absolute).removeAttr('style');
      // }
    }
  });
};



//////////////////
// WEBPACK FOOTER
// ./js/_modules/scroll.js
// module id = 2
// module chunks = 0